<template>
  <div class="card-content-wrapper">
    <div class="card-content-wrapper__top-line">
      <slot name="top-line" />
    </div>
    <div class="card-content-wrapper__mid-line">
      <slot name="mid-line" />
    </div>
    <div class="card-content-wrapper__bot-line">
      <slot name="bot-line" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupItemCardContent',
}
</script>

<style lang="scss" scoped>
.card-content-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  font-size: rem(10px);
  line-height: 12px;
  font-weight: 450;
  color: var(--athens-gray);

  @include tablet {
    font-size: rem(12px);
    line-height: 14px;
  }

  &__mid-line {
    margin: 5px 0px;
    height: 42px;
    color: var(--white);
    font-family: var(--font-medium);
    font-size: rem(12px);
    line-height: 14px;
    max-lines: 3;

    @include tablet {
      font-size: rem(16px);
      line-height: 23px;
      max-lines: 2;
      height: 46px;
    }
    @include desktop {
      max-lines: 1;
      height: 23px;
    }
  }
  &__bot-line {
    display: flex;
    column-gap: 10px;
    justify-content: center;
    align-items: center;
  }
}
</style>
